module.exports = __webpack_public_path__ + "static/media/gb.fcfef678.svg";